// extracted by mini-css-extract-plugin
module.exports = {"center":"center--AUNpU","small":"small--1i7lF"};